/*
  Document Printing PDP behavior (product.document-printing template)

  The "Sides" choice (Front Only / Front & Back) comes from the Globo Product
  Options app, and the FRONT / BACK upload fields come from the Uploadly app.
  Both render asynchronously, so this script:
    1. waits for both widgets to exist,
    2. hides the Uploadly "BACK" field whenever the selected Globo value is "Front Only",
    3. re-evaluates on every Globo change and whenever Uploadly re-renders its fields.
*/
(function () {
  'use strict';

  var HIDE_CLASS = 'dp-hide-back-upload';
  var FRONT_ONLY = /^\s*front\s*only\s*$/i;
  var FRONT_BACK = /front\s*(&|&amp;|and|\+|\/)\s*back|both\s*sides|two\s*sided|2\s*sided|double/i;
  var POLL_MS = 300;
  var TIMEOUT_MS = 30000;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  /* Returns 'front', 'both' or null (not chosen yet / option not found). */
  function selectedSides() {
    var inputs = document.querySelectorAll(
      '.gpo-app input[type="radio"]:checked, .gpo-app select, .gpo-app input[type="checkbox"]:checked'
    );
    for (var i = 0; i < inputs.length; i++) {
      var value = inputs[i].value || '';
      if (FRONT_ONLY.test(value)) return 'front';
      if (FRONT_BACK.test(value)) return 'both';
    }
    return null;
  }

  /* Uploadly wraps each field in [data-ph-wrap] > [data-ph-fieldname="..."]. */
  function backUploadWrappers() {
    var result = [];
    var fields = document.querySelectorAll('#photouploadapp [data-ph-fieldname]');
    for (var i = 0; i < fields.length; i++) {
      var field = fields[i];
      var name = field.getAttribute('data-ph-fieldname') || '';
      var label = field.querySelector('p');
      var labelText = label ? label.textContent : '';
      if (/back/i.test(name) || /back/i.test(labelText)) {
        result.push(field.closest('[data-ph-wrap]') || field);
      }
    }
    return result;
  }

  function apply() {
    var wrappers = backUploadWrappers();
    if (!wrappers.length) return;
    var hide = selectedSides() === 'front';
    wrappers.forEach(function (el) {
      el.classList.toggle(HIDE_CLASS, hide);
    });
  }

  function whenBothRendered(callback) {
    var elapsed = 0;
    var timer = setInterval(function () {
      var globo = document.querySelector('.gpo-app input, .gpo-app select');
      var uploadly = document.querySelector('#photouploadapp [data-ph-fieldname]');
      if (globo && uploadly) {
        clearInterval(timer);
        callback();
      } else if ((elapsed += POLL_MS) >= TIMEOUT_MS) {
        clearInterval(timer);
      }
    }, POLL_MS);
  }

  function observeUploadly() {
    var host = document.querySelector('.m-main-product') || document.body;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var target = mutations[i].target;
        if (target.closest && (target.closest('#photouploadapp') || target.closest('.gpo-app'))) {
          apply();
          return;
        }
      }
    });
    observer.observe(host, { childList: true, subtree: true });
  }

  function currentOptionValues() {
    var values = [];
    var groups = document.querySelectorAll('.m-product-option');
    for (var i = 0; i < groups.length; i++) {
      var checked = groups[i].querySelector('input[type="radio"]:checked');
      var select = groups[i].querySelector('select');
      if (checked && checked.value) values.push(checked.value);
      else if (select && select.value) values.push(select.value);
    }
    return values;
  }

  function selectedFinish() {
    return document.querySelector('[data-dp-finish-option]:checked');
  }

  function finishPriceCents() {
    var selected = selectedFinish();
    if (!selected) return 0;
    return parseInt(selected.getAttribute('data-dp-finish-price'), 10) || 0;
  }

  function updateFinishLabel(input) {
    var picker = document.querySelector('[data-dp-finish-picker]');
    var label = picker && picker.querySelector('[data-dp-finish-selected]');
    if (label && input) label.textContent = input.getAttribute('data-dp-finish-label') || input.value;
  }

  function rememberFinish() {
    var selected = selectedFinish();
    if (!selected || !window.history || !window.history.replaceState) return;
    var url = new URL(window.location.href);
    url.searchParams.set('dp_finish', selected.value);
    window.history.replaceState({}, '', url.toString());
  }

  function restoreFinishFromUrl() {
    var wanted = new URL(window.location.href).searchParams.get('dp_finish');
    if (!wanted) return;
    var inputs = document.querySelectorAll('[data-dp-finish-option]');
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value === wanted) {
        inputs[i].checked = true;
        updateFinishLabel(inputs[i]);
        return;
      }
    }
  }

  function documentVariantFromForm() {
    var idInput = document.querySelector('form[data-type="add-to-cart-form"] [name="id"]');
    var id = idInput ? parseInt(idInput.value, 10) : 0;
    var dataEl = document.getElementById('productData');
    if (!dataEl) return null;
    var product;
    try {
      product = JSON.parse(dataEl.textContent);
    } catch (error) {
      return null;
    }
    var variants = (product && product.variants) || [];
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === id) return variants[i];
    }
    return variants[0] || null;
  }

  function syncDisplayedPrice(variant) {
    if (!variant || typeof formatMoney !== 'function' || !window.MinimogSettings) return;
    var formatted = formatMoney(variant.price + finishPriceCents(), window.MinimogSettings.money_format);
    var root = document.querySelector('.main-product__block-price');
    if (!root) return;
    var regular = root.querySelector('.m-price__regular .m-price-item--regular');
    var sale = root.querySelector('.m-price-item--sale');
    if (regular) regular.innerHTML = formatted;
    if (sale) sale.innerHTML = formatted;
  }

  function cartAddUrl() {
    return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js';
  }

  function bindFinishCart(documentVariant) {
    var picker = document.querySelector('[data-dp-finish-picker]');
    if (!picker) return;

    picker.addEventListener('change', function (evt) {
      if (!evt.target.matches || !evt.target.matches('[data-dp-finish-option]')) return;
      updateFinishLabel(evt.target);
      rememberFinish();
      var error = picker.querySelector('[data-dp-finish-error]');
      if (error) error.hidden = true;
      syncDisplayedPrice(documentVariant.current);
    });

    var variantPicker = document.querySelector('variant-picker');
    var productId = variantPicker && variantPicker.getAttribute('data-product-id');
    if (productId && window.MinimogEvents) {
      window.MinimogEvents.subscribe(productId + '__VARIANT_CHANGE', function (variant) {
        documentVariant.current = variant;
        syncDisplayedPrice(variant);
        rememberFinish();
      });
    }

    document.addEventListener(
      'submit',
      function (evt) {
        var form = evt.target;
        if (!form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
        if (form.dataset.dpFinishPending === 'done') {
          delete form.dataset.dpFinishPending;
          return;
        }

        var selected = selectedFinish();
        if (!selected) return;
        var variantId = parseInt(selected.getAttribute('data-dp-finish-variant'), 10);
        if (!variantId) return;

        evt.preventDefault();
        evt.stopImmediatePropagation();

        var error = picker.querySelector('[data-dp-finish-error]');
        if (error) error.hidden = true;

        var submitButton = form.querySelector('[name="add"]');
        if (submitButton) submitButton.classList.add('m-spinner-loading');

        var properties = {};
        var productTitle = picker.getAttribute('data-dp-product-title');
        if (productTitle) properties['For Product'] = productTitle;

        fetch(cartAddUrl(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1, properties: properties }],
          }),
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(function (data) {
                throw new Error((data && (data.description || data.message)) || 'Could not add the finishing option.');
              });
            }
            return response.json();
          })
          .then(function () {
            form.dataset.dpFinishPending = 'done';
            var design = document.querySelector('[data-bc-design-selector] input[data-bc-design-option]:checked');
            if (design && design.value === 'custom') form.dataset.bcFeePending = 'done';
            if (typeof form.requestSubmit === 'function') {
              form.requestSubmit();
            } else {
              form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
            }
          })
          .catch(function (errorEvent) {
            if (error) {
              error.textContent = errorEvent.message;
              error.hidden = false;
            }
            if (submitButton) submitButton.classList.remove('m-spinner-loading');
          });
      },
      true
    );
  }

  function bestVariant(variants, selected) {
    var best = variants[0] || null;
    var bestScore = -1;
    for (var i = 0; i < variants.length; i++) {
      var score = 0;
      var options = variants[i].options || [];
      for (var j = 0; j < selected.length; j++) {
        if (options.indexOf(selected[j]) !== -1) score++;
      }
      if (score > bestScore) {
        bestScore = score;
        best = variants[i];
      }
    }
    return best;
  }

  function initSideSwitch(root) {
    var links = root.querySelectorAll('[data-dp-side-link]');
    for (var i = 0; i < links.length; i++) {
      links[i].addEventListener('click', function (evt) {
        if (this.classList.contains('is-current')) {
          evt.preventDefault();
          return;
        }
        var key = this.getAttribute('data-dp-side-link');
        var dataEl = root.querySelector('[data-dp-side-variants="' + key + '"]');
        if (!dataEl) return;
        var variants = [];
        try {
          variants = JSON.parse(dataEl.textContent);
        } catch (error) {
          return;
        }
        var match = bestVariant(variants, currentOptionValues());
        if (match && match.url) {
          evt.preventDefault();
          var nextUrl = new URL(match.url, window.location.origin);
          var finish = selectedFinish();
          if (finish) nextUrl.searchParams.set('dp_finish', finish.value);
          window.location.href = nextUrl.toString();
        }
      });
    }
  }

  function initDocumentPrintingPdp(root) {
    initSideSwitch(root);
    restoreFinishFromUrl();
    var documentVariant = { current: documentVariantFromForm() };
    syncDisplayedPrice(documentVariant.current);
    bindFinishCart(documentVariant);
    if (root.getAttribute('data-dp-side') !== 'front') return;
    var host = document.querySelector('.m-main-product') || document.body;
    var observer = new MutationObserver(function () {
      backUploadWrappers().forEach(function (el) {
        el.classList.add(HIDE_CLASS);
      });
    });
    observer.observe(host, { childList: true, subtree: true });
  }

  ready(function () {
    var pdp = document.querySelector('[data-dp-pdp]');
    if (pdp) {
      initDocumentPrintingPdp(pdp);
      return;
    }

    document.addEventListener('change', function (evt) {
      if (evt.target.closest && evt.target.closest('.gpo-app')) apply();
    });
    document.addEventListener('click', function (evt) {
      // Globo "buttons" swatches are labels; the radio change can fire before the
      // label state updates in some browsers, so re-check on the next tick.
      if (evt.target.closest && evt.target.closest('.gpo-app')) setTimeout(apply, 0);
    });

    whenBothRendered(function () {
      apply();
      observeUploadly();
    });
  });
})();
